// extracted by mini-css-extract-plugin
export default {"UsersList":"UsersList_UsersList__lfd6S"};